import { isBrowser as r } from "./highrise1350.mjs";
let t;
function d() {
  if (!r) return !0;
  if (t === void 0) {
    const e = document.createElement("div");
    e.style.display = "flex", e.style.flexDirection = "column", e.style.rowGap = "1px", e.appendChild(document.createElement("div")), e.appendChild(document.createElement("div")), document.body.appendChild(e);
    const n = e.scrollHeight === 1;
    return document.body.removeChild(e), t = n;
  }
  return t;
}
export {
  d as ensureSupportFlexGap
};
